<template>
  <v-icon
    v-bind="$attrs"
    :color="iconMapping.color"
    class="p-file-icon"
  >
    {{ iconMapping.icon }}
  </v-icon>
</template>


<script>
export default {
  props: {
    extension: {
      type: String
    },
    mimeType: {
      type: String
    }
  },


  data () {
    return {
      defaultMapping: {
        icon: 'mdi-file-outline',
        color: 'blue-grey darken-2'
      },
      mappings: [
        {
          ext: ['pdf'],
          mime: ['application/pdf'],
          icon: 'mdi-pdf-box',
          color: 'red'
        },
        {
          ext: ['zip', 'rar', '7z', 'tar', 'gz', 'mar', 'car', 'cab'],
          icon: 'mdi-folder-zip',
          color: 'amber accent-4'
        },
        {
          ext: ['doc', 'doct', 'wbk', 'docx', 'docm', 'dotx', 'dotm', 'docb'],
          icon: 'mdi-file-word-box',
          color: 'blue darken-4'
        },
        {
          ext: ['xls', 'xlt', 'xlm', 'xlsx', 'xlsm', 'xltx', 'xltm'],
          icon: 'mdi-file-excel-box',
          color: 'green darken-4'
        },
        {
          ext: ['ppt', 'pot', 'pps', 'pptx', 'pptm', 'potx', 'potm', 'ppam', 'ppsx', 'ppsm', 'sldx', 'sldm'],
          icon: 'mdi-file-powerpoint-box',
          color: 'deep-orange accent-3'
        },
        {
          ext: ['pub', 'xps'],
          icon: 'mdi-file-powerpoint-box',
          color: 'teal darken-4'
        },
        {
          ext: ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'tiff', 'exif', 'webp'],
          mime: ['image'],
          icon: 'mdi-image',
          color: 'teal darken-3'
        },
        {
          ext: ['txt', 'rtf'],
          mime: ['text'],
          icon: 'mdi-text-box-outline',
          color: 'blue-grey darken-3'
        },
        {
          ext: ['epub', 'fb2', 'djvu', 'ibooks', 'azw', 'azw3', 'kf8', 'kfx'],
          icon: 'mdi-book-outline',
          color: 'blue-grey darken-3'
        },
        {
          ext: ['webm', 'mkv', 'flv', 'vob', 'ogv', 'ogg', 'drc', 'avi', 'mov', 'wmv', 'mp4', 'm4p', 'mpg', 'mp2', 'mpeg', '3gp', 'flv'],
          mime: ['video'],
          icon: 'mdi-play-box-outline',
          color: 'red'
        },
        {
          ext: ['mp3', 'flac', 'm4a', 'wav', 'aac', 'mid', 'midi', 'kar'],
          mime: ['audio'],
          icon: 'mdi-music-box',
          color: 'green darken-4'
        }
      ]
    }
  },


  computed: {
    iconMapping () {
      let mapping
      let ext = this.extension

      if (!ext && this.mimeType) {
        const slashIndex = this.mimeType.indexOf('/')
        if (slashIndex !== -1) {
          ext = this.mimeType.substring(slashIndex + 1)
        }
      }

      if (ext) {
        mapping = this.mappings.find(m => m.ext.some(x => x === this.extension))
      }

      if (!mapping && this.mimeType) {
        mapping = this.mappings.find(m => m.mime.some(x => this.mimeType.startsWith(x)))
      }

      return mapping || this.defaultMapping
    }
  }
}
</script>
